"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADT = exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
const adt_1 = require("@morphic-ts/adt");
const Parameter_1 = require("./Parameter");
exports.Type = prelude_1.t.union([Parameter_1.UserAudio.Type, Parameter_1.Person.Type, Parameter_1.VIPUpload.Type]);
exports.ADT = (0, adt_1.makeADT)('type')({
    UO: (0, adt_1.ofType)(),
    PE: (0, adt_1.ofType)(),
    VU: (0, adt_1.ofType)()
});
//# sourceMappingURL=IAParameter.js.map